import React, { Component } from "react";

import { Link, withRouter } from "react-router-dom";

import JoinGym from "../../Container/JoinGym/JoinGym";
import JoinTrack from "../../Container/JoinTrack/JoinTrack";

import logo from "../../assets/Images/logo.png";

import style from "./AthleteRegistrationPage.module.css";

export default withRouter(
  class AthleteRegistrationPage extends Component {
    constructor() {
      super();

      this.state = {
        whichAccount: "JoinGym",
      };

      this.setState = this.setState.bind(this);
    }

    render() {
      return (
        <div className={style.container}>
          <div className={style.formContainer}>
            <div className="logo">
              <img src={logo} className="w-100" alt="not found" />
            </div>
            <hr />
            <div className="d-flex justify-content-around">
              <button
                type="button"
                className={`btn btn-rounded btn-icon colorWhite ${
                  this.state.whichAccount === "JoinGym"
                    ? "secondaryBgColor"
                    : "btn-secondary"
                }`}
                onClick={() => this.setState({ whichAccount: "JoinGym" })}
              >
                <span className="iconSize">1</span>
              </button>
              <button
                type="button"
                className={`btn btn-rounded btn-icon colorWhite ${
                  this.state.whichAccount === "AddProfilePicture"
                    ? "secondaryBgColor"
                    : "btn-secondary"
                }`}
              >
                <span className="iconSize">2</span>
              </button>
            </div>
            <div className="d-flex justify-content-around mt-2 pl-3">
              <p>Join Your Gym</p>
              <p>Join Your Tracks</p>
            </div>
            <div className="p-3">
              {this.state.whichAccount === "JoinGym" ? (
                <JoinGym setNextPage={this.setState} />
              ) : this.state.whichAccount === "AddProfilePicture" ? (
                <JoinTrack />
              ) : null}
            </div>
          </div>
          <div className="cornerBtnStyle">
            <Link to="/login" className="text-white">
              <button className="basicBtnStyle secondaryBtn">Login</button>
            </Link>
          </div>
        </div>
      );
    }
  }
);
